<template>
  <b-container class="d-flex flex-column h-100" fluid>
    <div
      class="pagetitle-container d-flex justify-content-start align-items-center"
    >
      <div class="page-title">
        <h2>Prevádzka</h2>
      </div>
      <div>
        <select-picker
          ref="picker"
          v-model="energetics_id"
          :label="['powerNumber', 'gasNumber']"
          btn-class="m-0 font-weight-bold"
          btn-variant="white"
          class="h-100"
          fetch-url="energetics/list"
          placeholder="Vyberte odberné miesto"
          size="lg"
          track-by="id"
          @input="goTo"
          @selectedItem="setOperationId"
          @loaded="setOperationId"
        >
          <template #option="props">
            <div
              :class="`text-${props.option._type.const.toLowerCase()}`"
              class="font-weight-bold"
            >
              <icon
                :name="
                  $store.getters['energetic/getTypeByID'](props.option.typeID)
                    .icon
                "
                class="icon-fw"
                scale="0.75"
              />
              {{ props.option.powerNumber || props.option.gasNumber }}
            </div>
            <div v-if="props.option.localityName" class="text-muted fs-sm">
              {{ props.option.localityName }}
            </div>
          </template>
        </select-picker>
      </div>
      <single-date-picker
        v-model="date"
        format="MMMM yyyy"
        maximum-view="month"
        minimum-view="month"
        size="lg"
      />
      <div v-if="type && type === 'power'" class="ml-auto">
        <!--<b-btn
          v-b-tooltip.hover.bottom
          variant="outline-secondary"
          :to="{name:'customerEnergetics',params:{id:data.customer_id,energetics_id:data.id}}"
          title="Odberné miesto"
        >
          <b-icon icon="grid" />
        </b-btn>
        <b-btn
          v-b-tooltip.hover.bottom
          variant="outline-secondary"
          :to="{name:'reportConsumer',params:{energetics_id:data.id}}"
          title="Fakturačné dáta"
        >
          <b-icon icon="file-earmark-text" />
        </b-btn>-->
        <div class="d-flex">
          <b-nav class="nav-sub mr-2">
            <b-nav-item
              :active="operationView === 'devices'"
              @click="goToView({ name: 'devices' })"
            >
              <b-icon class="mr-1" icon="inboxes" />
              Meradlá
            </b-nav-item>
            <b-nav-item
              :active="operationView === 'measuring'"
              @click="goToView({ name: 'measuring' })"
            >
              <b-icon class="mr-1" icon="sort-numeric-up-alt" />
              Meraná spotreba
            </b-nav-item>
          </b-nav>
          <!--          <b-btn
                      class="text-uppercase"
                      variant="primary"
                      @click="openAddMeasurerModal"
                    >
                      <b-icon
                        class="mr-1"
                        icon="plus"
                        scale="1.5x"
                      />
                      Pridať meradlo
                    </b-btn>-->
        </div>
      </div>
    </div>
    <add-measurer ref="measurerForm" />
    <div class="flex-grow-1" style="min-height: 1px">
      <b-overlay
        :blur="null"
        :show="loading && selectLoading"
        class="h-100"
        opacity="0"
      >
        <transition mode="out-in" name="fadeDownShort">
          <div v-if="!loading && !selectLoading" v-bar class="bar-out vb">
            <div>
              <component
                :is="`${type}View`"
                v-if="type"
                :consumer="consumerData"
                :summary="summary"
              />
            </div>
          </div>
        </transition>
      </b-overlay>
    </div>
  </b-container>
</template>
<script>
import SelectPicker from '@/components/inputs/SelectPicker'
import SingleDatePicker from '@/components/inputs/SingleDatePicker'
import PowerView from './power/View'
import GasView from './gas/View'
import operationService from '@/services/api/operationService'

import AddMeasurer from './AddMeasurer'
import getPeriod from './mixins/getPeriod'
import { mapState } from 'vuex'

export default {
  components: {
    SelectPicker,
    SingleDatePicker,
    PowerView,
    GasView,
    AddMeasurer,
  },
  mixins: [getPeriod],
  data() {
    return {
      loading: false,
      selectLoading: false,
      energetics_id: parseInt(this.$route.params.energetics_id),
      consumerData: {},
      summary: {},
      operationView: 'measuring',
    }
  },
  computed: {
    ...mapState({
      operation: (state) => state.operation.current,
    }),
    date: {
      get() {
        return this.$moment(
          `${this.$route.query.year}-${this.$route.query.month}`,
          'YYYY-MM',
        ).format('YYYY-MM-DD')
      },
      set(val) {
        this.$router
          .push({
            params: this.$route.params,
            query: {
              year: this.$moment(val, 'YYYY-MM-DD').year(),
              month: this.$moment(val, 'YYYY-MM-DD').month() + 1,
            },
          })
          .catch(() => {})
      },
    },
    type() {
      return this.$store.getters['energetic/getCurrentType']
    },
  },
  watch: {
    date(val, old) {
      if (val !== old) {
        this.getCurrent().then(() => {
          if (this.type === 'power') {
            this.fetchData()
          }
        })
      }
    },
    '$route.query': {
      immediate: true,
      handler(query) {
        if (!Object.keys(query).length) {
          this.$router.push({
            query: {
              year: this.$moment().year(),
              month: this.$moment().month() + 1,
            },
          })
        }
      },
    },
  },
  mounted() {
    this.$root.$on('operation.openMeasurerModal', this.openAddMeasurerModal)
  },
  created() {
    this.selectLoading = true
  },
  beforeDestroy() {
    this.$root.$off('operation.openMeasurerModal')
  },
  methods: {
    goTo(id) {
      if (parseInt(this.$route.params.energetics_id) !== id) {
        this.$router.push({
          params: {
            energetics_id: this.energetics_id,
          },
          query: this.$route.query,
        })
      }
    },
    setOperationId(val) {
      this.selectLoading = true
      this.$store.dispatch('operation/setCurrent', val.operation_data)
      this.getCurrent().then(() => {
        if (this.type === 'power') {
          this.fetchData()
        }
        this.selectLoading = false
      })
    },
    goToView(view) {
      this.operationView = view.name
      this.$root.$emit('operation.view', view)
    },
    fetchData() {
      this.loading = true
      return Promise.all([this.getConsumerData(), this.getSummary()])
        .then(([consumer, summary]) => {
          if (consumer) {
            this.consumerData = consumer.data.data.length
              ? consumer.data.data[0]
              : {}
          }
          if (summary) {
            this.summary = {
              totalConsumption: summary.data.totalConsumption,
              totalMeasurers: summary.data.totalDevices,
            }
          }
          this.operationView = 'measuring'
        })
        .catch((err) => {
          this.$swal({
            type: 'error',
            position: 'top',
            showCloseButton: true,
            text: 'Vyskytla sa chyba',
            timer: 5000,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    getCurrent() {
      if (this.energetics_id) {
        return this.$store.dispatch('energetic/getCurrent', {
          id: this.energetics_id,
          params: {
            filter: null,
          },
        })
      }
    },
    getConsumerData() {
      if (
        this.energetics_id &&
        this.$route.query.year &&
        this.$route.query.month
      ) {
        return this.$api.get(
          `reports/${this.energetics_id}/consumer/get_report`,
          {
            params: {
              year: this.$route.query.year,
              month: this.$route.query.month,
              filter: 'amountNT;amountVT;sopo',
            },
          },
        )
      }
    },
    getSummary() {
      if (
        this.operation.callback_id &&
        this.$route.query.year &&
        this.$route.query.month
      ) {
        return operationService.getDeviceDataSummaryByDeliveryPointId(
          this.$store.getters['operation/get'].callback_id,
          {
            periodFrom: this.period.from,
            periodTo: this.period.to,
          },
        )
      }
    },
    openAddMeasurerModal({ id = null }) {
      this.$refs.measurerForm.id = id
      this.$nextTick(() => {
        this.$root.$emit('modal-show', 'add-measurer')
      })
    },
  },
}
</script>
